 // src/redux/actions/jobTypeActions.js
import {
    FETCH_SKILL_REQUEST,
    FETCH_SKILL_SUCCESS,
    FETCH_SKILL_FAILURE,
    SET_SELECTED_SKILL,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchSkill = (FID) => async (dispatch) => {
    dispatch({ type: FETCH_SKILL_REQUEST });
  
    try {
      const response = await axios.get(`/MasterData/GetSkillsDDL?FIID=${FID}`);
      let skillList =response.data.responseData.map((val)=>{
        return{
          value:val.id,
          label:val.name,
        }
    })
      dispatch({
        type: FETCH_SKILL_SUCCESS,
        payload: skillList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_SKILL_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const selectSkill = (skillId) => ({
    type: SET_SELECTED_SKILL,
    payload: skillId,
  });
  